import React, { useEffect, useRef, useState } from 'react';
import { gigyaResendVerificationCode } from '../../../../actions/registerActions';
import { openHelp } from '../../../../actions/helpActions';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_LOGIN } from '../../../../constants/Routes';
import Spinner from '../../../common/spinner/Spinner';
import Heading from '../../../common/heading/Heading';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';
import Message from '../../../common/message/Message';
import AccountNavLink from '../../../common/links/AccountNavLink';
import {
	ONBOARDING_ERROR_UNVERIFIED_EMAIL_TITLE,
	ONBOARDING_VERIFY_EMAIL_TITLE,
	ONBOARDING_VERIFY_EMAIL_SENT_SUBTITLE,
	ONBOARDING_ERROR_UNVERIFIED_EMAIL_DESCRIPTION,
	ONBOARDING_VERIFY_EMAIL_SUBTITLE,
	ONBOARDING_VERIFY_EMAIL_RESEND_EMAIL,
	ONBOARDING_VERIFY_EMAIL_SENT_AGAIN,
	ONBOARDING_VERIFY_EMAIL_SENT_CHECK_SPAM,
	ONBOARDING_VERIFY_EMAIL_SENT_AGAIN_LINK,
	ONBOARDING_VERIFY_EMAIL_RESEND_EMAIL_LINK,
	ONBOARDING_VERIFY_EMAIL_RESEND_CHECK_SPAM,
} from '../../../../constants/Copy';
import useOnboardingTracking from '../../../../hooks/useOnboardingTracking';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_ACTION_EMAIL_RESEND,
	EVT_FUNNEL,
	EVT_ELEMENT_INTERACTION,
	EVT_ACTION_EMAIL_VERIFY,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_VERIFY,
	EVT_TEXT_LINK,
} from '../../../../constants/SnowplowEvents';
import { useHistory } from 'react-router';

export default function VerifyEmail() {
	const email = useSelector((state) => state.authentication.email);
	const registerRegToken = useSelector((state) => state.register.regToken);
	const authToken = useSelector((state) => state.authentication.gigyaUser.regToken);
	const isLoggedIn = !!authToken;
	const regToken = registerRegToken || authToken;
	const [isLoading, setIsLoading] = useState(false);
	const [isResent, setIsResent] = useState(false);
	const dispatch = useDispatch();
	const timerRef = useRef(null);
	const history = useHistory();
	useOnboardingTracking();

	useEffect(() => {
		if (!email || !regToken) history.push(ROUTE_LOGIN);
	});

	useEffect(() => {
		if (isLoading) {
			clearTimeout(timerRef.current);
			timerRef.current = window.setTimeout(function () {
				setIsLoading(false);
			}, 1000);
		}
		return () => {
			clearTimeout(timerRef.current);
		};
	}, [isLoading]);

	const resendAction = () => {
		initiateTrackStructEvent({
			category: EVT_FUNNEL,
			action: EVT_ACTION_EMAIL_RESEND,

			rtlElementContext: {
				elementInteraction: EVT_ELEMENT_INTERACTION,
				elementGroup: EVT_ACTION_EMAIL_VERIFY,
				elementType: EVT_ELEMENT_TYPE_BUTTON,
				elementName: EVT_VERIFY,
				elementLabel: ONBOARDING_VERIFY_EMAIL_RESEND_EMAIL_LINK,
				elementStyle: EVT_TEXT_LINK,
			},
		});
		dispatch(gigyaResendVerificationCode({ regToken, email }));
		setIsResent(true);
		setIsLoading(true);
	};

	const openHelpAction = () => {
		dispatch(openHelp());
	};

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<div className="onboarding-verify-email">
					<OnboardingProgress activeStep={2} partiallyCompleted />
					<Heading>
						<span
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: !isLoggedIn
									? ONBOARDING_ERROR_UNVERIFIED_EMAIL_TITLE
									: ONBOARDING_VERIFY_EMAIL_TITLE,
							}}
						/>
					</Heading>
					<p className="onboarding__text">
						<Message
							message={
								isResent
									? ONBOARDING_VERIFY_EMAIL_SENT_SUBTITLE
									: isLoggedIn
									? ONBOARDING_ERROR_UNVERIFIED_EMAIL_DESCRIPTION
									: ONBOARDING_VERIFY_EMAIL_SUBTITLE
							}
							values={{ email: <strong className="onboarding__bold">{email}</strong> }}
						/>
					</p>
					<AccountNavLink>
						<span className="onboarding-verify-email__footer-text">
							{isResent ? ONBOARDING_VERIFY_EMAIL_SENT_AGAIN : ONBOARDING_VERIFY_EMAIL_RESEND_EMAIL}
							<br />
							{isResent
								? ONBOARDING_VERIFY_EMAIL_SENT_CHECK_SPAM
								: ONBOARDING_VERIFY_EMAIL_RESEND_CHECK_SPAM}
							<a
								className="onboarding__link accent"
								tabIndex="0"
								onClick={isResent ? openHelpAction : resendAction}
							>
								{isResent
									? ONBOARDING_VERIFY_EMAIL_SENT_AGAIN_LINK
									: ONBOARDING_VERIFY_EMAIL_RESEND_EMAIL_LINK}
							</a>
						</span>
					</AccountNavLink>
				</div>
			)}
		</>
	);
}
